<form class="card-form" [formGroup]="form" (submit)="submit()">
  <mat-card>
    <mat-card-title i18n="title @@auth.form.reset">
      Change your password
    </mat-card-title>

    <mat-card-content>
      <p class="mat-typography light" i18n="text @@auth.validate.explanation">
        Use 10 to 20 characters, at least one lowercase letter, one uppercase letter and
        one digit.
      </p>

      <p>
        <tc-password-field formControlName="plainPassword" [autofocus]="true"></tc-password-field>
      </p>

      <p *ngIf="errorMessage">
        <mat-error>{{ errorMessage }}</mat-error>
      </p>
    </mat-card-content>

    <mat-card-actions>
      <button type="submit" mat-raised-button color="primary" [disabled]="form.disabled" i18n="button @@auth.form.reset.submit">
        CHANGE
      </button>
    </mat-card-actions>
  </mat-card>
</form>
